import { Button, theme } from "antd";
import React from "react";

import { StickyButtonProps } from "./types";

export const StickyButton: React.FC<StickyButtonProps> = ({
  onClick,
  icon,
  children,
  zIndex,
}) => {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        position: "absolute",
        bottom: "1rem",
        display: "block",
        width: "100%",
        zIndex,
        textAlign: "center",
      }}
    >
      <Button
        onClick={onClick}
        style={{
          margin: "auto",
          padding: "1.25rem 1.75rem",
          background: token.colorText,
          color: token.colorWhite,
          fontWeight: 700,
        }}
        icon={icon}
      >
        {children}
      </Button>
    </div>
  );
};
